import { NgModule, Injector, ErrorHandler, Injectable, InjectionToken } from '@angular/core'
import { HttpModule } from '@angular/http'
import { RouterModule } from '@angular/router'
import { NoopAnimationsModule } from '@angular/platform-browser/animations'
import { CoreModule } from './core/core.module'
import { ModelsModule } from './models/models.module'
import { APP_ROUTES } from './app.routes'
import { AppComponent } from './app.component'
import * as Rollbar from 'rollbar'
import { Constants } from "config/constants"
import { authorizationConfig } from './config'
import { HttpClientModule } from '@angular/common/http'
import * as Hammer from 'hammerjs'
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser'

export var APP_INJECTOR

const ENV = Constants.ENV

const rollbarConfig = {
  accessToken: '5073743e83ad44ac90c820963f09e0cc',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: (ENV.isProduction ? true : false)
}

export class HammerConfig extends HammerGestureConfig {
  overrides = <any> {
    swipe: { direction: Hammer.DIRECTION_ALL, velocity: 0.1 },
    tap: { enable: false }, 
    doubletap: { enable: false },
    pan: { enable: false }, 
    press: { enable: false },
    pinch: { enable: false }, 
    rotate: { enable: false }
  };
}

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(err: any): void {
    console.log("handleError:", err, err.message)

    const chunkFailedMessage = /Loading chunk [\d]+ failed/

    if (chunkFailedMessage.test(err.message)) {
      window.location.reload()
    }
    else {
      if (err.alreadySent) return
      err.alreadySent = true
      const rollbar = this.injector.get(RollbarService)
      rollbar.error(err.originalError || err)
      throw err
    }
  }
}

export function rollbarFactory() {
    return new Rollbar(rollbarConfig);
}

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@NgModule({
  imports: [
    NoopAnimationsModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot(APP_ROUTES, { useHash: false }),
    CoreModule.forRoot({ authorizationConfig: authorizationConfig }),
    ModelsModule.forRoot({})
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    }
  ]
})

export class AppModule {
  constructor(injector: Injector) {
    APP_INJECTOR = injector
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/app.module.ts